import "../styles/Projects.css";
import YouTube from "react-youtube";

export default function Projects() {
  const onPlayerReady = (event) => {
    event.target.pauseVideo();
  };

  const opts = {
    height: "390",
    width: "640",
    playerVars: {
      autoplay: 0,
      controls: 1,
      modestbranding: 1,
      rel: 0,
    },
  };

  return (
    <section className="projects">
      <h2 className="projects__title">PROJECTS</h2>
      <section className="projects__projects-list">
        <div className="projects__project">
          <div className="projects__project-description">
            <h3 className="projects__project-title">
              Board Game Review Website
            </h3>
            <p>
              A mobile- and desktop-friendly rating website allowing users to
              share reviews on various board games. Users can also create, edit,
              and delete comments on reviews, as well as upvote reviews authored
              by other users.
            </p>
            <p className="note">
              Note: This website depends on a back-end hosted on Heroku and may
              take a few seconds to spin up.
            </p>
            <div className="projects__project-buttons">
              <a
                href="https://board-games-reviews-fe-project.netlify.app/"
                target="_blank"
                rel="noreferrer"
              >
                <button className="projects__btn">Hosted version</button>
              </a>
              <a
                href="https://github.com/callumu21/Board-Games-Reviews-FE"
                target="_blank"
                rel="noreferrer"
              >
                <button className="projects__btn">Source code</button>
              </a>
            </div>
          </div>
          <div className="projects__vid-container">
            <YouTube
              videoId="-rEkv4uFExI"
              opts={opts}
              onReady={onPlayerReady}
            />
          </div>
        </div>
      </section>
    </section>
  );
}
